<template>
  <div class="video-thumbnail-container">
    <div class="video-thumbnail-content">
      <slot name="video-thumbnail"></slot>
      <div class="play-icon-overlay">
        <v-icon large>mdi-play</v-icon>
      </div>
    </div>
    <span class="video-title-container">
      <slot name="video-title"></slot>
    </span>
  </div>
</template>

<script lang="js">
export default {
  name: 'VideoThumbnail'
}
</script>

<style lang="scss">
.video-thumbnail-container {
  padding: 5px;
  font-weight: 600;
  font-size: 15px;
  .video-thumbnail-content {
    position: relative;
    margin-bottom: 5px;
    img {
      height: 100%;
      width: 100%;
    }
    .play-icon-overlay {
      position: absolute;
      bottom: 0;
      z-index: 10;
      background-color: #fff;
    }
  }
}
</style>
